import { MenuListItem, MenuListItemIcon } from "@/components/ui/MenuList";
import { notification } from "@/components/ui-deprecated";
import { useIsDeveloper } from "@/hooks/useIsDeveloper";
import { useResetPermissionCacheMutation } from "@/store/services/permission-cache.service";

type Props = {
    onSubmit?: () => void;
};

const ResetPermissionCacheMenuItem = (props: Props) => {
    const isDeveloper = useIsDeveloper();

    const [resetPermissionCache, { isLoading }] = useResetPermissionCacheMutation();

    if (!isDeveloper) return null;

    const handleResetPermissionCache = async () => {
        if (isLoading) return;

        try {
            await resetPermissionCache().unwrap();
            notification.success("Permission cache reset successfully");
            props.onSubmit?.();
        } catch {
            notification.warning("Failed to reset permission cache");
        }
    };

    return (
        <>
            <MenuListItem onClick={handleResetPermissionCache}>
                <MenuListItemIcon icon={"lely-icon-reset"} />
                {isLoading ? "Resetting Permission Cache..." : "Reset Permission Cache"}
            </MenuListItem>
        </>
    );
};

export { ResetPermissionCacheMenuItem };
